import React, { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Box, Grid, Typography, Button, useMediaQuery, useTheme } from '@mui/material';

const CarouselUs = () => {

  useEffect(() => {
    const enriqueBanner = document.getElementById('enrique-name-banner');
    const erikaBanner = document.getElementById('erika-name-banner');
    const edwinBanner = document.getElementById('edwin-name-banner');

    if (enriqueBanner && erikaBanner && edwinBanner) {
      enriqueBanner.style.visibility = 'visible';
      erikaBanner.style.visibility = 'hidden';
      edwinBanner.style.visibility = 'hidden';
    }
  }, []);

  const [showMoreEnrique, setShowMoreEnrique] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleCarouselChange = (now) => {
    const enriqueBanner = document.getElementById('enrique-name-banner');
    const erikaBanner = document.getElementById('erika-name-banner');
    const edwinBanner = document.getElementById('edwin-name-banner');

    // Reinicia estado de "ver más"
    setShowMoreEnrique(false);

    if (enriqueBanner && erikaBanner && edwinBanner) {
      enriqueBanner.style.visibility = 'hidden';
      erikaBanner.style.visibility = 'hidden';
      edwinBanner.style.visibility = 'hidden';

      if (now === 0) {
        enriqueBanner.style.visibility = 'visible';
      } else if (now === 1) {
        erikaBanner.style.visibility = 'visible';
      } else if (now === 2) {
        edwinBanner.style.visibility = 'visible';
      }
    }
  };


  const toggleAdditionalContent = () => {
    setShowMoreEnrique((prev) => !prev);
  };

  const enriqueItems = [
    "• Colegio de Contadores Públicos de Sonora, A.C. desde el año de 1999.",
    "• Colegio Nacional de Consejeros Profesionales Independientes de Empresas, A.C.",
    "• Instituto Mexicano de Mejores Prácticas Corporativas, A.C. desde 2017.",
    "• Family Firm Institute de Boston 2021.",
    "• Asociación nacional de abogados de empresa 2021.",
    "• World Compliance Association 2021.",
    "• Coparmex Sonora Norte desde 2017."
  ];

  const edwinItems = [
    "• Cofundador de Pitic Capital, entidad financiera dedicada a la dispersión e inyección de capital estratégico para acelerar el desarrollo y crecimiento del sector empresarial.",
    "• Maestro en Ingeniería Económica Financiera por la Universidad La Salle",
    "• Especialista en Valuación de Negocios por TN University.",
  ];

  return (
    <Carousel
      animation="fade"
      autoPlay={!isMobile} // 👈 activo en desktop, desactivado en mobile
      navButtonsAlwaysVisible={!isMobile}
      indicators={false}
      sx={{
        maxWidth: '1238px',
        margin: '0 auto',
        borderRadius: { xs: 0, md: 4 },
        overflow: 'visible',
        '& .CarouselItem': {
          overflow: 'visible !important',
        },
        pt: { xs: '20px', md: '70px' },
      }}
      onChange={handleCarouselChange}
    >
      {/* Slide 1 - Enrique */}
      <Paper id="enrique-slide" sx={{
        height: { xs: 'auto', md: '576px' },
        background: 'linear-gradient(90deg, #000000 50%, #666666 170%)',
        color: '#fff',
        p: { xs: '16px', md: '30px' },
        borderRadius: { xs: 0, md: '20px' },
        position: 'relative',
        overflow: 'hidden',
      }}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190049/ebm/fondoDecorativo_gq3oio.png"
          alt="Decorativo"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            top: { xs: '20%', md: '30%' },
            transform: 'rotate(-6deg) scale(1.1)',
            zIndex: 0,
            height: { xs: '300px', md: '470px' },
            opacity: 0.5,
            pointerEvents: 'none',
            display: { xs: 'none', md: 'block' },
          }}
        />
        <Grid container spacing={2} sx={{ height: '100%' }}>
          <Grid item xs={12} md={5} sx={{
            order: { xs: 1, md: 2 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
            height: { xs: '220px', md: '100%' },
            minHeight: { xs: '220px', md: 'auto' },
            mb: { xs: 2, md: 0 }
          }}>
            <Box
              component="img"
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190062/ebm/EnriqueBarrera_ce2qju.png"
              alt="Enrique Barrera"
              sx={{
                width: { xs: '180px', sm: '280px', md: '370px' },
                height: { xs: 'auto', md: '100%' },
                maxHeight: { xs: '220px', md: 'none' },
                objectFit: 'contain',
                borderRadius: '10px',
                marginBottom: { xs: '-150px', md: '-150px' },
                ml: { xs: 0, md: '-180px' },
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} sx={{
            order: { xs: 2, md: 1 },
            display: 'flex',
            flexDirection: 'column',
            px: { xs: 0, sm: 2 }
          }}>
            <Typography
              sx={{
                position: 'absolute',
                top: { xs: '60px', md: '85px' },
                right: { xs: '100px', md: '120px', xl: '140px' },
                fontSize: { xs: '10px', sm: '14px' },
                fontWeight: 400,
                fontFamily: 'Poppins, sans-serif',
                color: '#D4A76A',
                zIndex: 3,
              }}
            >
              C.P.C. | L.D. | C.C.G.C. | M.D.C. | M.I. | P.C.FI.
            </Typography>

            <Box className="content-container" sx={{
              position: 'relative',
              zIndex: 1,
              flexGrow: 1,
              overflow: 'hidden',
              height: isMobile && !showMoreEnrique ? '300px' : 'auto',
              pb: { xs: 4, sm: 0 },
              transition: 'height 0.3s ease-in-out',
            }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: { xs: '12px', sm: '14px' },
                  color: 'white',
                  textAlign: { xs: 'justify', sm: 'justify' },
                  lineHeight: 1.6,
                  fontWeight: 300,
                  mt: { xs: 8, md: 10 },
                  maxWidth: '90%',
                  ml: { xs: 2, sm: 5 }
                }}
              >
                Fundador y director de BR Consultores, consorcio dedicado a la asesoría y consultoría con más de 30 años participando en el desarrollo de empresas. Consejero Profesional Independiente de Empresas.
                Fundador y Director de Lecosy (Legal Compliance System), empresa
                dedicada a la creación de plataformas tecnológicas en materia de
                cumplimiento legal y fiscal. <br />
                Cuento con múltiples estudios y participo activamente en diversas organizaciones entre ellas:
              </Typography>

              <Box>
                {enriqueItems.slice(0, isMobile && !showMoreEnrique ? 3 : enriqueItems.length).map((item, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: { xs: '12px', sm: '14px' },
                      color: 'white',
                      mt: 1.5,
                      textAlign: { xs: 'left', sm: 'justify' },
                      lineHeight: 1.6,
                      fontWeight: 600,
                      maxWidth: '90%',
                      ml: { xs: 2, sm: 5 }
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* Botón Ver más */}
            {isMobile && (
              <Button
                variant="text"
                sx={{
                  color: '#D4A76A',
                  textTransform: 'none',
                  fontSize: '12px',
                  fontWeight: 600,
                  mt: 1,
                  alignSelf: 'center',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline'
                  }
                }}
                onClick={toggleAdditionalContent}
              >
                {showMoreEnrique ? 'Ver menos' : 'Ver más'}
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>

      {/* Slide 2 - Erika */}
      <Paper id="erika-slide" sx={{
        height: { xs: 'auto', md: '576px' },
        background: 'linear-gradient(90deg, #000000 50%, #666666 170%)',
        color: '#fff',
        p: { xs: '16px', md: '30px' },
        borderRadius: { xs: 0, md: '20px' },
        position: 'relative',
        overflow: 'hidden',
      }}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190049/ebm/fondoDecorativo_gq3oio.png"
          alt="Decorativo"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            top: { xs: '20%', md: '30%' },
            transform: 'rotate(-6deg) scale(1.1)',
            zIndex: 0,
            height: { xs: '300px', md: '470px' },
            opacity: 0.5,
            pointerEvents: 'none',
            display: { xs: 'none', md: 'block' },
          }}
        />
        <Grid container spacing={2} sx={{ height: '100%' }}>
          <Grid item xs={12} md={5} sx={{
            order: { xs: 1, md: 2 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
            height: { xs: '220px', md: '100%' },
            minHeight: { xs: '220px', md: 'auto' },
            mb: { xs: 2, md: 0 }
          }}>
            <Box
              component="img"
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750189842/ebm/ErikaIbarra_kgdlqu.png"
              alt="Erika Ibarra"
              sx={{
                width: { xs: '180px', sm: '280px', md: '370px' },
                height: { xs: 'auto', md: '100%' },
                maxHeight: { xs: '220px', md: 'none' },
                objectFit: 'contain',
                borderRadius: '10px',
                marginBottom: { xs: '-105px', md: '-90px' },
                ml: { xs: 0, md: '-150px' },
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} sx={{
            order: { xs: 2, md: 1 },
            display: 'flex',
            flexDirection: 'column',
            px: { xs: 0, sm: 2 }
          }}>
            <Typography
              sx={{
                position: 'absolute',
                top: { xs: '55px', md: '85px' },
                right: { xs: '160px', md: '200px', xl: '220px' },
                fontSize: { xs: '12px', sm: '14px' },
                fontWeight: 400,
                fontFamily: 'Poppins, sans-serif',
                color: '#D4A76A',
                zIndex: 3,
              }}
            >
              L.A.E. | M.B.A.
            </Typography>

            <Box sx={{
              position: 'relative',
              zIndex: 1,
              flexGrow: 1,
            }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: { xs: '12px', sm: '14px' },
                  color: 'white',
                  textAlign: { xs: 'justify', sm: 'justify' },
                  lineHeight: 1.6,
                  fontWeight: 300,
                  mt: { xs: 8, md: 15 },
                  maxWidth: '90%',
                  ml: { xs: 2, sm: 5 }
                }}
              >
                Consultor líder de gobierno
                corporativo y empresa familiar
                con experiencia en la
                implementación de procesos de
                planeación estratégica, diseño
                de modelos de negocio, asesoría
                a empresas familiares y
                establecimiento de estructuras
                de gobierno corporativo a
                diferentes empresas.
              </Typography>

              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: { xs: '12px', sm: '14px' },
                    color: 'white',
                    mt: 1.5,
                    textAlign: { xs: 'justify', sm: 'justify' },
                    lineHeight: 1.6,
                    fontWeight: 600,
                    maxWidth: '90%',
                    ml: { xs: 2, sm: 5 }
                  }}
                >
                  • Miembro de la comisión de Desarrollo humano y
                  sostenibilidad en Coparmex Sonora.
                </Typography>

                <Typography
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: { xs: '12px', sm: '14px' },
                    color: 'white',
                    mt: 1.5,
                    textAlign: { xs: 'justify', sm: 'justify' },
                    lineHeight: 1.6,
                    fontWeight: 600,
                    maxWidth: '90%',
                    ml: { xs: 2, sm: 5 }
                  }}
                >
                  • Seminario en gobernabilidad
                  corporativa por el Instituto
                  Mexicano de Mejores Prácticas
                  Corporativas, A.C. ampliando su
                  conocimiento en áreas clave
                  relacionadas con el gobierno corporativo y la gestión
                  empresarial.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Slide 3 - Edwin */}
      <Paper id="edwin-slide" sx={{
        height: { xs: 'auto', md: '576px' },
        background: 'linear-gradient(90deg, #000000 50%, #666666 170%)',
        color: '#fff',
        p: { xs: '16px', md: '30px' },
        borderRadius: { xs: 0, md: '20px' },
        position: 'relative',
        overflow: 'hidden',
      }}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190049/ebm/fondoDecorativo_gq3oio.png"
          alt="Decorativo"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            top: { xs: '20%', md: '30%' },
            transform: 'rotate(-6deg) scale(1.1)',
            zIndex: 0,
            height: { xs: '300px', md: '470px' },
            opacity: 0.5,
            pointerEvents: 'none',
            display: { xs: 'none', md: 'block' },
          }}
        />
        <Grid container spacing={2} sx={{ height: '100%' }}>
          <Grid item xs={12} md={5} sx={{
            order: { xs: 1, md: 2 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
            height: { xs: '220px', md: '100%' },
            minHeight: { xs: '220px', md: 'auto' },
            mb: { xs: 2, md: 0 }
          }}>
            <Box
              component="img"
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783099247/ebm/EdwinRuiz_e06gvv.png"
              alt="Edwin Ruiz"
              sx={{
                width: { xs: '180px', sm: '280px', md: '370px' },
                height: { xs: 'auto', md: '100%' },
                maxHeight: { xs: '220px', md: 'none' },
                objectFit: 'contain',
                borderRadius: '10px',
                marginBottom: { xs: '-105px', md: '-90px' },
                ml: { xs: 0, md: '-150px' },
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} sx={{
            order: { xs: 2, md: 1 },
            display: 'flex',
            flexDirection: 'column',
            px: { xs: 0, sm: 2 }
          }}>
            <Typography
              sx={{
                position: 'absolute',
                top: { xs: '55px', md: '85px' },
                right: { xs: '120px', md: '160px', xl: '180px' },
                fontSize: { xs: '10px', sm: '14px' },
                fontWeight: 400,
                fontFamily: 'Poppins, sans-serif',
                color: '#D4A76A',
                zIndex: 3,
              }}
            >
              L.F. | E.V.N. | M.I.E.F.
            </Typography>

            <Box sx={{
              position: 'relative',
              zIndex: 1,
              flexGrow: 1,
            }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: { xs: '12px', sm: '14px' },
                  color: 'white',
                  textAlign: { xs: 'justify', sm: 'justify' },
                  lineHeight: 1.6,
                  fontWeight: 300,
                  mt: { xs: 8, md: 15 },
                  maxWidth: '90%',
                  ml: { xs: 2, sm: 5 }
                }}
              >
                Consultor líder especializado en Finanzas Corporativas. Su práctica profesional se enfoca en dotar de certeza matemática a las decisiones de la Alta Dirección, dominando el ciclo completo de la estrategia empresarial: desde el diseño de inteligencia financiera y evaluación de proyectos de inversión, hasta la estructuración y levantamiento de capital privado.
              </Typography>

              <Box>
                {edwinItems.map((item, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: { xs: '12px', sm: '14px' },
                      color: 'white',
                      mt: 1.5,
                      textAlign: { xs: 'justify', sm: 'justify' },
                      lineHeight: 1.6,
                      fontWeight: 600,
                      maxWidth: '90%',
                      ml: { xs: 2, sm: 5 }
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Carousel>
  );
};

export default CarouselUs;